import {
  createRouter,
  parseSearchWith,
  stringifySearchWith,
} from "@tanstack/react-router";
import {
  RouteErrorComponent,
  NotFoundComponent,
} from "@mbits/mray-react-common";

// Import the generated route tree
import { routeTree } from "./routeTree.gen";

// Create a new router instance
export const router = createRouter({
  basepath: String(window.ENV?.basePath ?? "/"),
  routeTree,
  context: {},
  defaultErrorComponent: RouteErrorComponent,
  defaultNotFoundComponent: NotFoundComponent,
  defaultPreload: "intent",
  scrollRestoration: true,
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 0,
  // Keep search param values as plain strings instead of JSON-parsing them.
  // The default (JSON.parse) silently converts numeric-looking strings
  // (e.g. DICOM study UIDs) to JS numbers, losing precision.
  parseSearch: parseSearchWith((value) => value),
  stringifySearch: stringifySearchWith(String),
});

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
